import React from 'react';
import graph from './graph';

import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { ProductShopModel } from 'models';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';

export default function AssignSelectedProduct({ id, active, refetch, shop, products }) {
  const { userToken } = useSelector((state) => state.auth);
  
  const [assignment, { loading }] = useMutation(graph.assignment.query, {
    context: {
      serviceName: graph.assignment.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onAssign = async (selected, onClose) => {
    try {
      const { data, errors } = await assignment({
        variables: {
          coupon_id: id,
          assignment_type: 'SELECTED_PRODUCT',
          product_shop_ids: selected.map((item) => item.id),
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.assignment.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <ProductShopModel
        isPopup
        isAssign
        multiSelect
        disabled={loading}
        onAssign={onAssign}
        assigning={loading}
        title="محصولات انتخابی"
        initFilter={{ shop_ids: shop?.id }}
        preSelected={products.map((item) => ({ id: item.id, title: item.product_info.title }))}
        action={
          <Button
            fullWidth
            size="medium"
            color="primary"
            variant={active ? 'contained' : 'text'}
            sx={{ bgcolor: !active && 'primary.lighter' }}
          >
            انتخابی
          </Button>
        }
      />
    </>
  );
}
